// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new_team_steps__box {
    padding-top: var(--space-and-half);
    /*padding-left: var(--space-x3);
    padding-right: var(--space-x3);*/
    margin-left: calc(var(--space-x3) * 3.5);
    margin-right: calc(var(--space-x3) * 2);
}

.new_team_steps__box__title{
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}

.new_team_steps__box__title__text {
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: var(--space) !important;
    line-height: 20px !important;
    align-items: center;
    letter-spacing: 0.0015em;
    color: var(--basic-gray-color) !important;
    padding-right: var(--space-x3);
}

.new_team_steps__box__steps{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: var(--space-x3);
    margin-right: calc(var(--space-x3) + var(--space-half));
    margin-top: var(--space-half);
}

.new_team_steps__box__steps__point{
    width: calc(var(--space) * 2.2);
    height: calc(var(--space) * 2);
    border-radius: 50%;
    background: var(--new-gray-disabled-color);
}

.new_team_steps__box__steps__line{
    border-top: 3px solid;
    padding: 0;
    margin: 0 0 0 0;
    width: 100%;
    color: var(--new-line-color);
}

.new_team_steps__complete-text {
    color: var(--secondary-color) !important;
}

.new_team_steps__complete-point {
    background: var(--secondary-color) !important;
}

.new_team_steps__completed-text {
    color: var( --primary-very-dark-color) !important;
}

.new_team_steps__completed-point {
    background: var( --primary-very-dark-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-new-team-steps/LeagueNewTeamStepsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC;oCACgC;IAChC,wCAAwC;IACxC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,kCAAkC;IAClC,4BAA4B;IAC5B,mBAAmB;IACnB,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;IAC5B,uDAAuD;IACvD,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAG9B,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,sDAAsD;AAC1D","sourcesContent":[".new_team_steps__box {\n    padding-top: var(--space-and-half);\n    /*padding-left: var(--space-x3);\n    padding-right: var(--space-x3);*/\n    margin-left: calc(var(--space-x3) * 3.5);\n    margin-right: calc(var(--space-x3) * 2);\n}\n\n.new_team_steps__box__title{\n    display: flex;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.new_team_steps__box__title__text {\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: var(--space) !important;\n    line-height: 20px !important;\n    align-items: center;\n    letter-spacing: 0.0015em;\n    color: var(--basic-gray-color) !important;\n    padding-right: var(--space-x3);\n}\n\n.new_team_steps__box__steps{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-left: var(--space-x3);\n    margin-right: calc(var(--space-x3) + var(--space-half));\n    margin-top: var(--space-half);\n}\n\n.new_team_steps__box__steps__point{\n    width: calc(var(--space) * 2.2);\n    height: calc(var(--space) * 2);\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    background: var(--new-gray-disabled-color);\n}\n\n.new_team_steps__box__steps__line{\n    border-top: 3px solid;\n    padding: 0;\n    margin: 0 0 0 0;\n    width: 100%;\n    color: var(--new-line-color);\n}\n\n.new_team_steps__complete-text {\n    color: var(--secondary-color) !important;\n}\n\n.new_team_steps__complete-point {\n    background: var(--secondary-color) !important;\n}\n\n.new_team_steps__completed-text {\n    color: var( --primary-very-dark-color) !important;\n}\n\n.new_team_steps__completed-point {\n    background: var( --primary-very-dark-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
